// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"51e5112a","817":"373783b4"}[chunkId] + ".chunk.js";
};